import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import * as moment from 'moment-timezone';
import { DateFormat } from 'src/app/core/constants/app.constant';
import { BaseService } from 'src/app/core/services/base.service';
import { IResponse } from 'src/app/shared/models/app';


@Injectable({
  providedIn: 'root'
})
export class EodReportService extends BaseService {

  constructor(protected http: HttpClient) {
    super(http);
  }

  transformSignOff(data) {
    //data.signoffTime = moment(data.signoffTime).format();
    let newData: any = {};
    newData.signoffTime = data.signoffTime;
    newData.note = data.note;
    ['procedure', 'order', 'inventory', 'waste', 'task', 'personnel'].forEach((item) => {
      newData[item] = data.status[item];
    });
    return newData;
  }

  transformRecipients(recipients) {
    let retVal = [];
    recipients.forEach(recipient => {
      retVal.push({ id: recipient.id });
    });
    return retVal;
  }

  getSchedDays(eodConfig) {
    let retVal = '';
    for (let i = 1; i < 8; i++) {
      if (eodConfig.daysOfWeek[i]) {
        if (retVal != '') retVal += ',';
        retVal += i;
      }
    }
    return retVal;
  }

  transformEodConfig(eodConfig) {
    if (eodConfig.alertOn) {
      let timeString = eodConfig.dateTime;
      let dateString = moment(new Date()).format(DateFormat.MMDDYYYY);
      let dateTime = moment(dateString + ' ' + timeString, DateFormat.MMDDYYYYHMM);
      return {
        active: true, dateTime: dateTime, id: eodConfig.id ? eodConfig.id : null,
        schedDays: this.getSchedDays(eodConfig), recipients: this.transformRecipients(eodConfig.selectedRecipients)
      };
    } else {
      return { active: false };
    }
  }

  procedureStatus(date) {
    const url = this.apiConfig.config + '/api/procedure/count?date=' + moment(date).format();
    return super.fetch(url);
  }

  orderStatus(date) {
    const url = this.apiConfig.order + '/api/order/status?date=' + moment(date).format();
    return super.fetch(url);
  }

  expiredInventoryStatus(date) {
    const url = this.apiConfig.inventory + '/api/inventory/status?date=' + moment(date).format();
    return super.fetch(url);
  }

  rfdBinStatus(date) {
    const url = this.apiConfig.bin + '/api/bin/status?date=' + moment(date).format();
    return super.fetch(url);
  }

  taskCompletionStatus(date) {
    const url = this.apiConfig.hp + '/api/task/status?date=' + moment(date).format();
    return super.fetch(url);
  }

  personnelTaskCompletionStatus(date) {
    const url = this.apiConfig.hp + '/api/personnel/status?date=' + moment(date).format();
    return super.fetch(url);
  }

  signOff(date) {
    const url = this.apiConfig.config + '/api/eodreport';
    let data = this.transformSignOff(date);
    return super.post(url, data);
  }

  eodStatus(date) {
    const url = this.apiConfig.config + '/api/eodreport?date=' + moment(date).format();
    return super.fetch(url);
  }

  eodConfiguration() {
    const url = this.apiConfig.config + '/api/eodreport/config';
    return super.fetch(url);
  }

  eodCreateConfiguration(eodConfig) {
    const url = this.apiConfig.config + '/api/eodreport/config';
    return super.post(url, this.transformEodConfig(eodConfig));
  }

  eodUpdateConfiguration(eodConfig) {
    const url = this.apiConfig.config + '/api/eodreport/config';
    return super.put(url, this.transformEodConfig(eodConfig)).subscribe((res: IResponse) => {
      if (!res.hasError) {
        return true;
      } else {
        return false;
      }
    });
  }

  getDailyReport(dailyReportData, dailyreportid) {
    const url = this.apiConfig.report + '/api/report/request/' + dailyreportid;
    return super.post(url, dailyReportData, dailyreportid);
  }


}
